import React, { useState } from "react";

import Modal from "../../../components/modal/Modal";
import Textarea from "../../../components/form-item/Textarea";

/**
 * プルリクエスト送信の確認モーダル。
 *
 * エディタの「プルリクエスト」ボタンから開き、レビュアーへの説明コメントを
 * 添えて送信する。送信後は対象セクションのメンテナー / オーナーへメールで
 * 通知される。
 */

export interface SubmitChangeModalProps {
  /** 送信対象の表示名（ノート/カードのタイトル） */
  title: string;
  loading: boolean;
  /** 初期表示する説明コメント（下書きの説明を引き継ぐ場合） */
  initialDescription?: string;
  onSubmit: (description: string) => void;
  onClose: () => void;
}

const SubmitChangeModal: React.FC<SubmitChangeModalProps> = ({
  title,
  loading,
  initialDescription = "",
  onSubmit,
  onClose,
}) => {
  const [description, setDescription] = useState(initialDescription);

  return (
    <Modal
      title="プルリクエストを送信"
      titleSize="medium"
      description={`「${title}」の変更をレビュアーへ送信します。承認されると公開内容に反映されます。`}
      size="default"
      onClose={onClose}
      primaryAction={{
        label: loading ? "送信中..." : "プルリクエスト",
        onClick: () => onSubmit(description.trim()),
        loading,
      }}
      secondaryAction={{
        label: "キャンセル",
        onClick: onClose,
      }}
    >
      <Textarea
        label="説明コメント"
        option="optional"
        value={description}
        rows={4}
        maxLength={2000}
        placeholder="変更の意図や確認してほしいポイントなど"
        onChange={(e) => setDescription(e.target.value)}
      />
    </Modal>
  );
};

export default SubmitChangeModal;
